// BIM menu slice
import { createSlice } from "@reduxjs/toolkit";

export const bimMenuData = [
  { text: "Dashboard", link: "/dashboard" },
  { text: "Projects", link: "/projects" },
  { text: "Project Atlas", link: "/atlas" },
  {
    // Masters used by the IFC → BOQ flow only. 2D-layer, auto-link and agent
    // masters are hidden (those flows are out of scope in this UI).
    text: "Masters",
    link: "#",
    subMenu: [
      { text: "Rate Library (3D)", link: "/masters/rate-library" },
      { text: "Resource Catalog (3D)", link: "/masters/resources" },
      { text: "Exchange Rates (3D)", link: "/masters/exchange-rates" },
      { text: "Assemblies (3D)", link: "/masters/assemblies" },
      { text: "UOM (3D)", link: "/masters/uom" },
      { text: "IFC Classifications (3D)", link: "/masters/ifc-classifications" },
      { text: "Measurement Standards", link: "/masters/measurement-standards" },
      // same entry as the side menu (BIMSidebar): the org's AI provider keys / agents
      { text: "AI Configuration", link: "/masters/ai-configuration" },
      { text: "QTO Rules (3D)", link: "/masters/qto-rules" },
      { text: "User Access", link: "/masters/user-access" },
      { text: "Audit Log", link: "/masters/audit-log" },
    ],
  },
];

const menuSlice = createSlice({
  name: "menu",
  initialState: {
    data: bimMenuData as any[],
    loading: false,
    error: null as string | null,
  },
  reducers: {
    setMenu: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setMenu } = menuSlice.actions;
export default menuSlice.reducer;
